import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Standard shadcn `cn` helper — merges tailwind class strings + drops
 * conflicting utility classes (e.g., `p-2` vs `p-4` keeps the last).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
